module.exports = __webpack_public_path__ + "odinstatic/v6.4.0/media/sidebar-shield-active.c2b48cd4.svg";